import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GoogleButton from "react-google-button";
import { Typography } from "@mui/material";

import { LoginDivContainer, LoginImg } from "./SigninForm.style";
import { FormPage } from "../../components-old/ComponentsIndex";
import { AuthAPI, VantagePortalAPI } from "../../apis/api-index";
import logo from "../../assets/images/rentokil-logo.svg";
import { clearUser, setUser } from "../../store/slice-index";
import { DisplaySpinnerContext } from "../../context/ContextIndex";
import { FirebaseApp } from "../../apis/firebase-app";
import { selectUser } from "../../store/store-selector";

const SigninForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const spinnerCtx = useContext(DisplaySpinnerContext);

  const user = useSelector(selectUser);

  const [isNavigating, setIsNavigating] = useState(false);
  const [businessSourceListData, setbusinessSourceListData] = useState([]);

  const prepareBusinessSourceList = async () => {
    try {
      const resAccessLists = await VantagePortalAPI.getUserAccessList();
      if (resAccessLists && resAccessLists.length > 0) {
        let _resList = [];
        _resList = resAccessLists.map((item) => {
          let returnObj = {};
          if (item && item.businessCode && item.countryCode && item.businessDescription) {
            returnObj = {
              key: item.businessCode + "-" + item.countryCode,
              value: item.countryCode + "-" + item.businessDescription,
            };
          }
          return returnObj;
        });
        return _resList;
      }
    } catch (err) {
      alert(err);
    }
  };

  const handleSignIn = async () => {
    try {
      if (!FirebaseApp.isFirebaseAppInitialized()) {
        await FirebaseApp.init();
      }
      spinnerCtx.setLoadingIndicator(true);
      const response = await AuthAPI.googleSignIn();
      if (response) {
        dispatch(setUser(response));
        const responseList = await prepareBusinessSourceList();
        if (responseList && responseList.length > 0) {
          setbusinessSourceListData(responseList);
          setIsNavigating(true);
          // navigate("/login", { state: businessSourceListData });
        } else {
          alert("No Business Source Available");
          await AuthAPI.logOut();
        }
        spinnerCtx.setLoadingIndicator(false);
      }
    } catch (err) {
      alert(err);
    }
  };

  const handleSignOut = async () => {
    try {
      await AuthAPI.logOut();
      dispatch(clearUser());
      navigate("/");
    } catch (err) {
      alert(err);
    }
  };

  useEffect(() => {
    const invokeSignout = async () => {
      await handleSignOut();
    };
    invokeSignout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user && isNavigating) {
      navigate("/login", { state: businessSourceListData });
    }
  }, [isNavigating, businessSourceListData, navigate, user]);

  return (
    <FormPage isLoginFlow={true}>
      <LoginDivContainer
        divStyle={{
          divMinHeight: "100vh",
          divFontSize: {
            mobileS: "30",
            mobileL: "25",
            tablet: "40",
            laptopL: "20",
          },
        }}
      >
        <LoginImg src={logo} alt="logo" />
        <Typography variant="bannerTextDarkBg">{t("login.header")}</Typography>
        <GoogleButton style={{ marginTop: "20px", width: "280px" }} onClick={handleSignIn} label={t("login.signInGoogle")} />
      </LoginDivContainer>
    </FormPage>
  );
};

export default SigninForm;
